import React from 'react';

export default function ProductRecommendations({ reason = "basé sur vos favoris", products = [] }) {
  if (!products.length) return null;

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%)',
        border: '1px solid rgba(99, 102, 241, 0.2)',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <span style={{ fontSize: '18px' }}>🤖</span>
        <div>
          <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' }}>
            Recommandations personnalisées
          </p>
          <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-secondary)' }}>
            {reason}
          </p>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
          gap: '12px',
        }}
      >
        {products.slice(0, 4).map((product, idx) => (
          <div
            key={idx}
            style={{
              background: 'var(--bg-primary)',
              borderRadius: '8px',
              padding: '8px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = 'var(--shadow-md)')}
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}
          >
            <div style={{ fontSize: '24px', marginBottom: '4px' }}>📦</div>
            <p style={{ margin: 0, fontSize: '12px', fontWeight: '600', color: 'var(--text-primary)' }}>
              {product.name?.substring(0, 20)}...
            </p>
            <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#6366f1', fontWeight: '700' }}>
              ${product.price}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
